import { Chip, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useField, useFormikContext } from "formik";
import _ from "lodash";
import React from "react";

const useStyles = makeStyles(theme => ({
  textField: {
    "& > .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paper,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      "& > .MuiOutlinedInput-input": {
        padding: "14.5px 25px !important"
      }
    }
  }
}));

const MultipleAutocompleteField = ({
  name,
  label,
  variant,
  className,
  options,
  submitOnChange
}) => {
  const classes = useStyles();
  const [field] = useField(name);
  const { submitForm } = useFormikContext();

  return (
    <Autocomplete
      multiple
      className={className}
      getOptionLabel={option => option.label || ""}
      options={options}
      defaultValue={[]}
      freeSolo
      value={field.value || []}
      onChange={(_, selectedOptions) => {
        field.onChange({
          currentTarget: { name, value: selectedOptions.map(opt => opt.value || opt) || [] }
        });
        if (submitOnChange) {
          submitForm();
        }
      }}
      renderTags={(values, getTagProps) => {
        return values.map((value, index) => {
          return (
            <Chip
              key={value}
              variant="outlined"
              label={_.find(options, { value })?.label || value}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...getTagProps({ index })}
            />
          );
        });
      }}
      renderInput={params => (
        <TextField
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
          label={label}
          variant={variant}
          className={classes.textField}
        />
      )}
    />
  );
};

export default MultipleAutocompleteField;
